export const DOMAIN = 'https://movie0706.cybersoft.edu.vn';
export const TOKEN = 'accessToken';
export const USERLOGIN = 'userLogin';
export const TYPE_USER = 'typeUser';
export const STICKETINFO = 'sticketInfo';